import styled from 'styled-components'
import { em } from 'polished'

import { BoxBase } from 'styles/components/layout'
import { Text } from 'shared/Typography'

export const Wrapper = styled.div`
  padding-top: ${em(40)};
  background-color: var(--color-W100);
  overflow: hidden;

  ${p => p.theme.mq.upLg} {
    padding-top: ${em(60)};
  }
`

export const Container = styled(BoxBase)`
  display: flex;
  flex-direction: column;

  ${p => p.theme.mq.downMd} {
  }
`

export const Alert = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: ${em(15)};
  max-width: ${em(600)};
  margin: 0 auto ${em(60)};
  padding: ${em(15)} ${em(15)};
  background: #F6F6F8;
  border-radius: ${em(15)};

  ${p => p.theme.mq.upMd} {
    align-items: center;
  }

  ${p => p.theme.mq.upLg} {
    max-width: ${em(926)};
    padding: ${em(15)} ${em(35)} ${em(15)};
    margin-bottom: ${em(132)};
    gap: ${em(10)};
  }
`

export const HeartImage = styled.img`
  display: block;
  max-width: ${em(40)};

  ${p => p.theme.mq.upLg} {
  }
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;

  ${p => p.theme.mq.upLg} {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
`

export const ImageBlock = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  order: 2;
  gap: ${em(10)};
  margin-bottom: ${em(40)};
  color: var(--color-D100);

  & > div {
    position: absolute;
    top: ${em(-60)};

    ${p => p.theme.mq.upMd} {
      top: ${em(-40)};
    }

    ${p => p.theme.mq.upLg} {
      top: ${em(-50)};
    }

    &:first-of-type {
      left: 23%;

      ${p => p.theme.mq.upMd} {
        left: 36%;
      }

      ${p => p.theme.mq.upLg} {
        left: 19%;
      }
    }

    &:last-of-type {
      left: 58%;

      ${p => p.theme.mq.upMd} {
        left: 54%;
      }

      ${p => p.theme.mq.upLg} {
        left: 48%;
      }
    }
  }

  ${p => p.theme.mq.upLg} {
    order: 1;
    gap: ${em(15)};
    margin-bottom: 0;
  }
`

export const Image = styled.img`
  display: block;
  flex-shrink: 0;
  flex-grow: 1;

  ${p => p.theme.mq.upMd} {
    margin: 0 auto;
    max-width: 50%;
  }

  ${p => p.theme.mq.upLg} {
    margin: 0 0 0 ${em(-76)};
    max-width: ${em(730)}
  }
`

export const TextBlock = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  order: 1;
  gap: ${em(10)};
  margin-bottom: ${em(88)};
  text-align: center;
  color: var(--color-D100);

  ${p => p.theme.mq.upMd} {
    margin-bottom: ${em(100)};
  }

  ${p => p.theme.mq.upLg} {
    order: 2;
    gap: ${em(20)};
    max-width: ${em(483)};
    margin-bottom: ${em(91)};
    margin-left: ${em(-15)};
    text-align: left;
  }
`

export const Title = styled(Text)`
  span {
    color: var(--color-V50);
  }
`

export const Description = styled(Text)`
`
